var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"router-progress-bar",class:{ 'is-finishing': _vm.finishing },style:({ width: _vm.progress + '%' })}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }